import { useTranslation } from 'react-i18next'

export const AttendanceSaveBar = ({ presentCount, totalCount, extraCount, hasUnsaved, isSaving, onSave }) => {
    const { t } = useTranslation()
    return (
        <div className="sticky bottom-0 left-0 right-0 bg-white border-t shadow-md px-4 py-3 flex items-center justify-between z-10">
            <div className="text-sm text-gray-700">
                <span>{t('workforce.attendance.summary', { present: presentCount, total: totalCount, extra: extraCount })}</span>
                {hasUnsaved && <span className="ml-2 text-amber-700 font-medium">· {t('workforce.attendance.unsaved')}</span>}
            </div>
            <button
                type="button"
                onClick={onSave}
                disabled={!hasUnsaved || isSaving}
                className="px-4 py-2 rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
            >
                {isSaving ? t('workforce.saving') : t('workforce.save')}
            </button>
        </div>
    )
}
